/**
 * Product suppliers service: CRUD and list by product_id / supplier_id.
 */
import axios from 'axios';
import { authHeaders } from './apiAuth';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

/**
 * Get product_suppliers, optionally filtered by product_id and/or supplier_id.
 * @param {string} accessToken - User's JWT
 * @param {{ product_id?: number, supplier_id?: number }} params - Optional filters
 * @returns {Promise<{ success: boolean, product_suppliers: Array }>}
 */
export const getProductSuppliers = async (accessToken, { product_id, supplier_id } = {}) => {
  const params = {};
  if (product_id != null) params.product_id = product_id;
  if (supplier_id != null) params.supplier_id = supplier_id;
  const response = await axios.get(`${API_BASE_URL}/api/product-suppliers`, {
    headers: authHeaders(accessToken),
    params
  });
  return response.data;
};

/**
 * Create a product_supplier. product_id and supplier_id are required.
 * @param {string} accessToken - User's JWT
 * @param {Object} data - { product_id, supplier_id, origin?, unit_price?, moq?, stored_location?, available_amount?, default_sale_price?, sale_price_currency?, unit_price_currency? }
 * @returns {Promise<{ success: boolean, product_supplier?: Object }>}
 */
export const createProductSupplier = async (accessToken, data) => {
  const response = await axios.post(
    `${API_BASE_URL}/api/product-suppliers`,
    { product_supplier: data },
    { headers: authHeaders(accessToken) }
  );
  return response.data;
};

/**
 * Update a product_supplier by id.
 * @param {string} accessToken - User's JWT
 * @param {number} productSupplierId - products_suppliers.id
 * @param {Object} data - Partial fields to update
 * @returns {Promise<{ success: boolean, product_supplier?: Object }>}
 */
export const updateProductSupplier = async (accessToken, productSupplierId, data) => {
  const response = await axios.put(
    `${API_BASE_URL}/api/product-suppliers/${productSupplierId}`,
    { product_supplier: data },
    { headers: authHeaders(accessToken) }
  );
  return response.data;
};

/**
 * Delete a product_supplier by id.
 * @param {string} accessToken - User's JWT
 * @param {number} productSupplierId - products_suppliers.id
 * @returns {Promise<{ success: boolean }>}
 */
export const deleteProductSupplier = async (accessToken, productSupplierId) => {
  const response = await axios.delete(
    `${API_BASE_URL}/api/product-suppliers/${productSupplierId}`,
    { headers: authHeaders(accessToken) }
  );
  return response.data;
};
